import React from 'react'
import Title from '../../../atoms/Title'
import Card from '../../../molecules/Card'
import statimg from "../../../../assets/pics/stat/statisticsimg.png"
import world from "../../../../assets/pics/stat/world.png"
import chess from "../../../../assets/pics/stat/statchess.png"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
export default function Statisticssection({data}) {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const onStatClick = (screen)=>{
    // console.log("statistics section}", screen)
    if(screen==="fields"){
      navigate('/fields')
    }
    else if(screen==="characters"){
      navigate('/characters')
      // navigate("/allnews")
    }
  }
  return (
    <div className='h-fit py-5 mt-[10px] px-4'>
       <div className='h-1/6 flex justify-start items-center ms-[25px] '>
                  <div className='pb-[8px]'>

                     <Title primary>{t("home.stats.title")}</Title>
                  </div>  
                <div className="h-[3px] w-[120px] md:w-[670px] lg:w-[880px] bg-[#F5F5F5] mx-[10px] md:mx-[20px] lg:mx-[80px]"></div>
        </div>

        <div className='bg-[#D8D7D7] p-2 md:p-6 h-4/6 md:h-5/6 mx-4 mt-2 border border-amber rounded-[8px] flex flex-row justify-evenly items-center'>
            <div className='w-1/4 cursor-pointer' onClick={()=>onStatClick("fields")}>
            <Card
                vertical
                small
                imageSrc={statimg}
                alt={"image in statistics section2"}
                title={`${t("home.stats.specialties")}    ${data?.totalFieldsSpeciality}`}
                stat_square
              />
            </div>
            <div className='w-1/4 cursor-pointer' onClick={()=>onStatClick("fields")}>
              <Card
                vertical
                small
                imageSrc={world}
                alt={"image in statistics section3"}
                title={`${t("home.stats.fields")}   ${data?.totalFields}`}
                stat_square
              />
            </div>
            <div className='w-1/4 cursor-pointer' onClick={()=>onStatClick("characters")}>
            <Card
                vertical
                small
                imageSrc={chess}
                alt={"image in statistics section1"}
                title={`${t("home.stats.characters")}     ${data?.totalCharacters}`}
                stat_square
              />
            </div>
        </div>
    </div>
  )
}
